<template>
  <component
    :is="component"
    :class="variation"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>

export default {
  name: 'Surface',

  props: {
    variation: {
      type: String,
      default: 'Surface'
    },
    component: {
      type: [ String, Object ],
      default: 'div'
    }
  }
}

</script>

<style scoped>

.Surface {
	
	@apply
		border
		bg-white
		rounded
		border-solid
		border-dull
  /*
   * the surface has rounded corners & no opinion on the contents,
   * meaning that the contents could potentially have non-rounded
   * corners and like that, overflow the surface container at its
   * corners making the border look weird in those areas
   *
   * overflow: hidden clips that, might cause other trouble though
   *
   * EDIT: this messes with position: sticky (and with other things
   * to come as well potentially)
   *
   * TODO: find a different way to achieve the same result
   */
  /* overflow: hidden; */
}

</style>
